import { AxiosError, AxiosResponse } from "axios";
import { Dayjs } from "dayjs";
import http from "utilities/http-common";

const baseUrl = "/api/SignUser";

export async function getUsers(tenantId?: string): Promise<SignUser[]> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return await http
        .get(baseUrl, { params })
        .then((response: AxiosResponse<SignUser[]>) => {
            return response.data;
        });
}

export async function getNames(tenantId?: string): Promise<SignerNameDto[]> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return await http
        .get(`${baseUrl}/names`, { params })
        .then((response: AxiosResponse<SignerNameDto[]>) => {
            return response.data;
        });
}

export async function addSingUsers(dateFrom: Dayjs, dateTo: Dayjs, name: string, employeePoliceId: string, tenantId?: string): Promise<SignUser> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return await http.post(baseUrl, { dateFrom, dateTo, name, employeePoliceId }, { params })
        .then((response: AxiosResponse<SignUser>) => {
            return response.data;
        });
}

export async function deleteSignUser(id: string, tenantId?: string): Promise<void> {
    const params = new URLSearchParams();
    if (tenantId) {
        params.append("tenantId", tenantId);
    }

    return await http.delete(`${baseUrl}?id=${id}`, { params })
        .then((response: AxiosResponse<void>) => {
            return response.data;
        });
}